<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mt-0" color="rgb(250, 250, 250)">
          <v-card-text>
            <v-row class="mt-0" justify="center" dense>
              <v-col>
                <h1>Módulo en desarrollo o mantenimiento. En breve estará disponible</h1>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({

  }),

  computed: {

  },

  mounted() {
  },

  methods: {



  },
};
</script>
